import {matchAsUtcDate} from '../Services/datetime';

export interface IMatch {
    Idt: number;
    Num: number;
    Hre: string;
    Stade_Idt?: number;
    Stade_Nom: string;
    Stade_Capacite: number;
    Ville_Nom: string;
    Fnt_cod: string;
    Phs_Cod: string;
    Phs_Lvl?: number;
    // Numero of the M-type matchatt slot configured for this match's
    // home/away side, when the match comes after the group phase.
    // Kind is 'W' (winner of N) or 'L' (loser of N — used by the
    // 3rd-place playoff to pull from the semi-final losers).
    Expected_Dom_Num?: number | null;
    Expected_Ext_Num?: number | null;
    Expected_Dom_Kind?: 'W' | 'L' | null;
    Expected_Ext_Kind?: 'W' | 'L' | null;
    Is_Third_Place?: boolean | number;
    Dte: string;
    DteHre: Date;
    MatchTeam_Idt_Dom: number;
    team_idt_Dom: number;
    Team_Clr_Dom: string;
    Nom_Dom: string;
    Score_Dom: number;
    MatchTeam_Idt_Ext: number;
    team_idt_Ext: number;
    Team_Clr_Ext: string;
    Nom_Ext: string;
    Score_Ext: number;
    Grp_Cod: string;
    Journee_Lib: string;
    BetScore_Dom?: number;
    BetScore_Ext?: number;
    // MySQL TINYINT(1) lands here as 0/1 depending on driver settings.
    finished?: boolean | number;
}

export const HasMatchStarted = (match: IMatch): boolean => {
    const start = matchAsUtcDate(match.Dte, match.Hre);
    if (!start) return false;
    return start.getTime() < Date.now();
};

// A match is considered "in progress" from kickoff up to kickoff + 120 min
// (90 min play + 15 min half-time + 15 min stoppage cushion). After that
// window it's considered finished, regardless of whether scores landed.
export const MATCH_IN_PROGRESS_WINDOW_MS = 120 * 60 * 1000;
export const IsMatchInProgress = (match: IMatch): boolean => {
    const start = matchAsUtcDate(match.Dte, match.Hre);
    if (!start) return false;
    const now = Date.now();
    return start.getTime() <= now && now < start.getTime() + MATCH_IN_PROGRESS_WINDOW_MS;
};

export const HasMatchResults = (match: IMatch): boolean => {
    const result: boolean = (match.Score_Dom ?? -1) !== -1 && (match.Score_Ext ?? -1) !== -1;
    // console.log(`Score Dom ${match.Score_Dom} - Score Ext ${match.Score_Ext} - result = ${result}`);
    return result;
};